module.exports = __webpack_public_path__ + "img/ico-facebook.1d1cd217.svg";